import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataComplianceStatusesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataComplianceStatusesReducer.staticDataComplianceStatusesFeatureKey]
);

export const getStaticDataComplianceStatusesFailure = createSelector(
  getStaticDataComplianceStatusesState,
  staticDataCountriesReducer.fromStaticDataComplianceStatusesReducer.getComplianceStatusesError
);

export const getStaticDataComplianceStatusesResponse = createSelector(
  getStaticDataComplianceStatusesState,
  staticDataCountriesReducer.fromStaticDataComplianceStatusesReducer.getComplianceStatuses
);
